module.exports = __webpack_public_path__ + "static/media/he-IL.6b660d47.md";